export default __webpack_public_path__ + "static/media/header-bg.a166b2ee.webp";